import { Module } from 'vuex';
import CommuneState from '@/types/store/CommuneState';
import RootState from '@/types/store/RootState';

import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const module: Module<CommuneState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default module;
